import { Routes } from "@angular/router";

export const authenticatedSignatureRoutes: Routes = [
  {
    path: "",
    pathMatch: "full",
    loadComponent: () =>
      import("./mobile-signature-list-page/mobile-signature-list-page.component").then(
        (moduleExports) => moduleExports.MobileSignatureListPageComponent
      ),
  },
  {
    path: ":uid",
    loadComponent: () =>
      import("./mobile-authenticated-signature-page/mobile-authenticated-signature-page.component").then(
        (moduleExports) => moduleExports.MobileAuthenticatedSignaturePageComponent
      ),
  },
];
